"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.service = exports.DELETE = exports.PUT = exports.POST = exports.GET = void 0;
const axios_1 = __importDefault(require("axios"));
const axios_2 = __importDefault(require("axios"));
const store_1 = require("../store/redux/store");
const utils_1 = require("../services/utils");
const account_1 = require("../store/redux/account");
const authStorage_1 = require("../services/authStorage");
const config_1 = require("../config/config");
const utils_2 = require("./utils");
const react_native_1 = require("react-native");
const utils_mobile_1 = require("./utils_mobile");
exports.GET = 'GET';
exports.POST = 'POST';
exports.PUT = 'PUT';
exports.DELETE = 'DELETE';
const service = async (requestType, route, data = {}, config = {}) => {
    const state = store_1.store.getState();
    const expDate = state.account.expDate;
    let accessToken = state.account.accessToken;
    if (accessToken && expDate && (0, utils_1.isTokenExpired)(expDate)) {
        const refreshToken = await (0, authStorage_1.authStorageManager)(authStorage_1.secureStorageActionTypes.GET, authStorage_1.secureStorageKeys.REFRESH_TOKEN);
        return await axios_2.default.post(config_1.API_URL + 'account/refresh', { refresh_token: refreshToken }, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${accessToken}`,
            }
        }).then(refreshTokenResponse => {
            const { data: refreshTokenData } = refreshTokenResponse;
            (0, authStorage_1.storeAuthItems)(refreshTokenData.access_token, refreshTokenData.refresh_token, refreshTokenData.expire);
            store_1.store.dispatch((0, account_1.authenticateAction)({
                accessToken: refreshTokenData.access_token,
                expDate: String(refreshTokenData.expire)
            }));
            accessToken = refreshTokenData.access_token;
            if (data.hasOwnProperty('refresh_token')) {
                data.refresh_token = refreshTokenData.refresh_token;
            }
            return make(requestType, route, data, config, accessToken);
        });
    }
    else {
        return await make(requestType, route, data, config, accessToken);
    }
};
exports.service = service;
const make = (requestType, route, data = {}, config = {}, accessToken) => {
    if (accessToken)
        config.headers = { Authorization: `Bearer ${accessToken}` };
    config.headers = { ...config.headers, 'Content-Type': 'application/json' };
    const make_put_post_request = async (callback) => {
        if (config_1.USE_SIGNATURE) {
            let signedData;
            if (react_native_1.Platform.OS === 'web') {
                signedData = await (0, utils_2.signData)(data);
            }
            else {
                signedData = await (0, utils_mobile_1.signDataMobile)(data);
            }
            return callback(config_1.API_URL + route, signedData, config);
        }
        else {
            return callback(config_1.API_URL + route, data, config);
        }
    };
    switch (requestType) {
        case exports.GET: {
            return axios_1.default.get(config_1.API_URL + route, config);
        }
        case exports.POST: {
            return make_put_post_request(axios_1.default.post);
        }
        case exports.PUT: {
            return make_put_post_request(axios_1.default.put);
        }
        case exports.DELETE: {
            return axios_1.default.delete(config_1.API_URL + route, config);
        }
        default: {
            throw new TypeError('No valid request type provided');
        }
    }
};
exports.default = exports.service;
